/**
 * Navigation Bar Component
 */
import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";

const Navbar = ({ isAuthenticated = false, user = null, onLogout }) => {
  const [schedulerDropdownOpen, setSchedulerDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setSchedulerDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <nav
      style={{
        position: "sticky",
        top: 0,
        zIndex: 50,
        backgroundColor: "white",
        borderBottom: "1px solid #e5e7eb",
        padding: "1rem 0",
        boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
      }}
    >
      <div
        style={{
          maxWidth: "1280px",
          margin: "0 auto",
          padding: "0 1rem",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {/* Logo */}
        <Link
          to="/"
          style={{
            textDecoration: "none",
            display: "flex",
            alignItems: "center",
            gap: "0.75rem",
          }}
        >
          <div
            style={{
              width: "44px",
              height: "44px",
              borderRadius: "12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
              overflow: "hidden",
            }}
          >
            <img
              src="/img/logo-ag.png"
              alt="AgentGarden Logo"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
            />
          </div>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontSize: "1.25rem",
                fontWeight: "bold",
                color: "#111827",
                lineHeight: "1.2",
              }}
            >
              AgentGarden
            </span>
            <span
              style={{
                fontSize: "0.75rem",
                color: "#6b7280",
                fontWeight: "500",
              }}
            >
              AI Automation Platform
            </span>
          </div>
        </Link>

        {/* Navigation Items */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "1rem",
          }}
        >
          {/* About link for all users */}
          <Link
            to="/about"
            style={{
              padding: "0.5rem 1rem",
              color: "#374151",
              textDecoration: "none",
              borderRadius: "0.375rem",
              transition: "background-color 0.2s",
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "#f3f4f6")}
            onMouseLeave={(e) =>
              (e.target.style.backgroundColor = "transparent")
            }
          >
            About
          </Link>

          {isAuthenticated ? (
            // Authenticated user menu
            <>
              <Link
                to="/dashboard"
                style={{
                  padding: "0.5rem 1rem",
                  color: "#374151",
                  textDecoration: "none",
                  borderRadius: "0.375rem",
                  transition: "background-color 0.2s",
                }}
                onMouseEnter={(e) =>
                  (e.target.style.backgroundColor = "#f3f4f6")
                }
                onMouseLeave={(e) =>
                  (e.target.style.backgroundColor = "transparent")
                }
              >
                Dashboard
              </Link>
              <Link
                to="/my-agents"
                style={{
                  padding: "0.5rem 1rem",
                  color: "#374151",
                  textDecoration: "none",
                  borderRadius: "0.375rem",
                  transition: "background-color 0.2s",
                }}
                onMouseEnter={(e) =>
                  (e.target.style.backgroundColor = "#f3f4f6")
                }
                onMouseLeave={(e) =>
                  (e.target.style.backgroundColor = "transparent")
                }
              >
                My Agents
              </Link>
              <Link
                to="/integrations"
                style={{
                  padding: "0.5rem 1rem",
                  color: "#374151",
                  textDecoration: "none",
                  borderRadius: "0.375rem",
                  transition: "background-color 0.2s",
                }}
                onMouseEnter={(e) =>
                  (e.target.style.backgroundColor = "#f3f4f6")
                }
                onMouseLeave={(e) =>
                  (e.target.style.backgroundColor = "transparent")
                }
              >
                Integrations
              </Link>

              {/* Scheduler Agent Dropdown */}
              <div ref={dropdownRef} style={{ position: "relative" }}>
                <button
                  onClick={() => setSchedulerDropdownOpen(!schedulerDropdownOpen)}
                  style={{
                    padding: "0.5rem 1rem",
                    color: "#374151",
                    textDecoration: "none",
                    borderRadius: "0.375rem",
                    transition: "background-color 0.2s",
                    backgroundColor: schedulerDropdownOpen ? "#f3f4f6" : "transparent",
                    border: "none",
                    cursor: "pointer",
                    fontSize: "1rem",
                    display: "flex",
                    alignItems: "center",
                    gap: "0.25rem",
                  }}
                  onMouseEnter={(e) =>
                    (e.target.style.backgroundColor = "#f3f4f6")
                  }
                  onMouseLeave={(e) =>
                    !schedulerDropdownOpen && (e.target.style.backgroundColor = "transparent")
                  }
                >
                  AI Agents
                  <svg
                    style={{
                      width: "16px",
                      height: "16px",
                      transform: schedulerDropdownOpen ? "rotate(180deg)" : "rotate(0deg)",
                      transition: "transform 0.2s",
                    }}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>

                {schedulerDropdownOpen && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      right: 0,
                      marginTop: "0.5rem",
                      backgroundColor: "white",
                      borderRadius: "0.5rem",
                      boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
                      border: "1px solid #e5e7eb",
                      minWidth: "200px",
                      zIndex: 100,
                    }}
                  >
                    <div style={{
                      padding: "0.5rem 1rem",
                      fontSize: "0.75rem",
                      fontWeight: "600",
                      color: "#9ca3af",
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                    }}>
                      Scheduling AI Agent
                    </div>
                    <Link
                      to="/scheduler"
                      onClick={() => setSchedulerDropdownOpen(false)}
                      style={{
                        display: "block",
                        padding: "0.75rem 1rem 0.75rem 1.5rem",
                        color: "#374151",
                        textDecoration: "none",
                        borderBottom: "1px solid #f3f4f6",
                        transition: "background-color 0.2s",
                      }}
                      onMouseEnter={(e) =>
                        (e.target.style.backgroundColor = "#f9fafb")
                      }
                      onMouseLeave={(e) =>
                        (e.target.style.backgroundColor = "transparent")
                      }
                    >
                      Dashboard
                    </Link>
                    <Link
                      to="/scheduler/links"
                      onClick={() => setSchedulerDropdownOpen(false)}
                      style={{
                        display: "block",
                        padding: "0.75rem 1rem 0.75rem 1.5rem",
                        color: "#374151",
                        textDecoration: "none",
                        borderBottom: "1px solid #f3f4f6",
                        transition: "background-color 0.2s",
                      }}
                      onMouseEnter={(e) =>
                        (e.target.style.backgroundColor = "#f9fafb")
                      }
                      onMouseLeave={(e) =>
                        (e.target.style.backgroundColor = "transparent")
                      }
                    >
                      Booking Pages
                    </Link>
                    <Link
                      to="/scheduler/links/new"
                      onClick={() => setSchedulerDropdownOpen(false)}
                      style={{
                        display: "block",
                        padding: "0.75rem 1rem 0.75rem 1.5rem",
                        color: "#374151",
                        textDecoration: "none",
                        borderBottom: "1px solid #f3f4f6",
                        transition: "background-color 0.2s",
                      }}
                      onMouseEnter={(e) =>
                        (e.target.style.backgroundColor = "#f9fafb")
                      }
                      onMouseLeave={(e) =>
                        (e.target.style.backgroundColor = "transparent")
                      }
                    >
                      New Booking Page
                    </Link>
                    <div style={{
                      padding: "0.5rem 1rem",
                      marginTop: "0.5rem",
                      fontSize: "0.75rem",
                      fontWeight: "600",
                      color: "#9ca3af",
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                    }}>
                      Event AI Agent
                    </div>
                    <Link
                      to="/events"
                      onClick={() => setSchedulerDropdownOpen(false)}
                      style={{
                        display: "block",
                        padding: "0.75rem 1rem 0.75rem 1.5rem",
                        color: "#374151",
                        textDecoration: "none",
                        borderBottom: "1px solid #f3f4f6",
                        transition: "background-color 0.2s",
                      }}
                      onMouseEnter={(e) =>
                        (e.target.style.backgroundColor = "#f9fafb")
                      }
                      onMouseLeave={(e) =>
                        (e.target.style.backgroundColor = "transparent")
                      }
                    >
                      Event Pages
                    </Link>
                    <Link
                      to="/events/create"
                      onClick={() => setSchedulerDropdownOpen(false)}
                      style={{
                        display: "block",
                        padding: "0.75rem 1rem 0.75rem 1.5rem",
                        color: "#374151",
                        textDecoration: "none",
                        borderBottom: "1px solid #f3f4f6",
                        transition: "background-color 0.2s",
                      }}
                      onMouseEnter={(e) =>
                        (e.target.style.backgroundColor = "#f9fafb")
                      }
                      onMouseLeave={(e) =>
                        (e.target.style.backgroundColor = "transparent")
                      }
                    >
                      Create Event
                    </Link>
                    <div style={{
                      padding: "0.5rem 1rem",
                      marginTop: "0.5rem",
                      fontSize: "0.75rem",
                      fontWeight: "600",
                      color: "#9ca3af",
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                    }}>
                      Meeting AI Agent
                    </div>
                    <div
                      style={{
                        display: "block",
                        padding: "0.75rem 1rem 0.75rem 1.5rem",
                        color: "#9ca3af",
                        borderBottom: "1px solid #f3f4f6",
                        cursor: "not-allowed",
                      }}
                    >
                      Coming Soon
                    </div>
                    <div style={{
                      padding: "0.5rem 1rem",
                      marginTop: "0.5rem",
                      fontSize: "0.75rem",
                      fontWeight: "600",
                      color: "#9ca3af",
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                    }}>
                      Settings
                    </div>
                    <Link
                      to="/scheduler/availability"
                      onClick={() => setSchedulerDropdownOpen(false)}
                      style={{
                        display: "block",
                        padding: "0.75rem 1rem 0.75rem 1.5rem",
                        color: "#374151",
                        textDecoration: "none",
                        borderBottom: "1px solid #f3f4f6",
                        transition: "background-color 0.2s",
                      }}
                      onMouseEnter={(e) =>
                        (e.target.style.backgroundColor = "#f9fafb")
                      }
                      onMouseLeave={(e) =>
                        (e.target.style.backgroundColor = "transparent")
                      }
                    >
                      Availability
                    </Link>
                    <Link
                      to="/scheduler/settings"
                      onClick={() => setSchedulerDropdownOpen(false)}
                      style={{
                        display: "block",
                        padding: "0.75rem 1rem 0.75rem 1.5rem",
                        color: "#374151",
                        textDecoration: "none",
                        transition: "background-color 0.2s",
                      }}
                      onMouseEnter={(e) =>
                        (e.target.style.backgroundColor = "#f9fafb")
                      }
                      onMouseLeave={(e) =>
                        (e.target.style.backgroundColor = "transparent")
                      }
                    >
                      Calendar Settings
                    </Link>
                  </div>
                )}
              </div>
              <Link
                to="/settings"
                style={{
                  padding: "0.5rem 1rem",
                  color: "#374151",
                  textDecoration: "none",
                  borderRadius: "0.375rem",
                  transition: "background-color 0.2s",
                }}
                onMouseEnter={(e) =>
                  (e.target.style.backgroundColor = "#f3f4f6")
                }
                onMouseLeave={(e) =>
                  (e.target.style.backgroundColor = "transparent")
                }
              >
                Settings
              </Link>
              <span
                style={{
                  color: "#6b7280",
                  fontSize: "0.875rem",
                  marginLeft: "0.5rem",
                }}
              >
                {user?.full_name || user?.email}
              </span>
              <button
                onClick={onLogout}
                style={{
                  padding: "0.5rem 1rem",
                  backgroundColor: "#dc2626",
                  color: "white",
                  border: "none",
                  borderRadius: "0.375rem",
                  cursor: "pointer",
                  fontSize: "0.875rem",
                  transition: "background-color 0.2s",
                }}
                onMouseEnter={(e) =>
                  (e.target.style.backgroundColor = "#b91c1c")
                }
                onMouseLeave={(e) =>
                  (e.target.style.backgroundColor = "#dc2626")
                }
              >
                Logout
              </button>
            </>
          ) : (
            // Guest user menu
            <>
              <Link
                to="/login"
                style={{
                  padding: "0.5rem 1rem",
                  color: "#374151",
                  textDecoration: "none",
                  borderRadius: "0.375rem",
                  transition: "background-color 0.2s",
                }}
                onMouseEnter={(e) =>
                  (e.target.style.backgroundColor = "#f3f4f6")
                }
                onMouseLeave={(e) =>
                  (e.target.style.backgroundColor = "transparent")
                }
              >
                Login
              </Link>
              <Link
                to="/register"
                style={{
                  padding: "0.5rem 1rem",
                  backgroundColor: "#7f51c9",
                  color: "white",
                  textDecoration: "none",
                  borderRadius: "0.375rem",
                  transition: "background-color 0.2s",
                }}
                onMouseEnter={(e) =>
                  (e.target.style.backgroundColor = "#6741a4")
                }
                onMouseLeave={(e) =>
                  (e.target.style.backgroundColor = "#7f51c9")
                }
              >
                Get Started
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
